
import React from "react";
import { Clock, ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";


interface BookingButtonProps {
  url?: string;
  scrolled?: boolean;
  isMobile?: boolean;
}

const BookingButton: React.FC<BookingButtonProps> = ({ 
  url = "https://zeeg.me/joerghoermann", 
  scrolled = false, 
  isMobile = false 
}) => {
  if (isMobile) {
    return (
      <a
        href={url}
        className="flex items-center gap-2 bg-primary text-white px-4 py-3 rounded-lg font-medium w-full shadow-sm hover:bg-primary-600 transition-colors"
        target="_blank"
        rel="noopener noreferrer"
        
      >
        <Clock size={18} />
        <div>
          <span className="block">Erstgespräch vereinbaren</span>
          <span className="text-xs text-primary-50">Kostenfrei, 30 Minuten</span>
        </div>
        <ExternalLink size={14} className="ml-auto" />
      </a>
    );
  }

  return (
    <a
      href={url}
      className={cn(
        "ml-2 xl:ml-4 px-3 xl:px-4 py-2 rounded-full text-xs xl:text-sm font-medium transition-colors flex items-center gap-1.5 xl:gap-2 shadow-sm whitespace-nowrap",
        scrolled
          ? "bg-primary text-white hover:bg-primary-600"
          : "bg-primary text-white hover:bg-primary-600"
      )}
      target="_blank"
      rel="noopener noreferrer"
      
    >
      <span className="hidden xl:inline">Kostenfreies Erstgespräch</span>
      <span className="xl:hidden">Erstgespräch</span>
      <Clock size={16} className="hidden md:inline" />
      <span className="hidden xl:inline text-xs bg-white/30 px-2 py-0.5 rounded-full">30 Min</span>
      <ExternalLink size={14} className="ml-1" />
    </a>
  );
};

export default BookingButton;
